import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import HeartSeasonTest from "./components/HeartSeasonTest";
import ResultadoPage from "./components/ResultadoPage";
import ModoEncontro from "./components/ModoEncontro";
import { Toaster } from "./components/ui/toaster";

// Página principal - Teste das Estações
const TestePage = () => {
  const handleClose = React.useCallback(() => {
    // Redireciona para o site principal do livro
    const bookSiteUrl = process.env.REACT_APP_BOOK_SITE_URL || 'https://www.ocoracaodetodasascoisas.com/';
    window.location.href = bookSiteUrl;
  }, []);
  
  return <HeartSeasonTest onClose={handleClose} />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Página principal: Teste das Estações */}
          <Route path="/" element={<TestePage />} />
          
          {/* Rota alternativa do teste */}
          <Route path="/teste" element={<TestePage />} />
          
          {/* Página de Resultado Público */}
          <Route path="/resultado/:sessionId" element={<ResultadoPage />} />
          
          {/* Bússola do Encontro (modo casal) */}
          <Route path="/encontro" element={<ModoEncontro />} />
          <Route path="/encontro/:codigo" element={<ModoEncontro />} />
          
          {/* Rota legada */}
          <Route path="/teste-estacoes" element={<TestePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
